import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

export const BrandDetailsModal = ({
    isOpen,
    onClose,
    companyName,
    brandName,
    companyEmail,
    companyPhone,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="bg-white rounded-lg shadow-xl w-full max-w-md"
            >
                <div className="flex justify-between items-center p-6 border-b border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-900">Brand Details</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        <FaTimes size={20} />
                    </button>
                </div>

                <div className="p-6">
                    <div className="space-y-4">
                        <div className="flex justify-between items-center py-2 border-b border-gray-100">
                            <span className="text-sm text-gray-600">Company Name</span>
                            <span className="text-sm font-medium text-gray-900">
                                {companyName || 'Not available'}
                            </span>
                        </div>

                        <div className="flex justify-between items-center py-2 border-b border-gray-100">
                            <span className="text-sm text-gray-600">Brand Name</span>
                            <span className="text-sm font-medium text-gray-900">
                                {brandName || 'Not available'}
                            </span>
                        </div>

                        <div className="flex justify-between items-center py-2 border-b border-gray-100">
                            <span className="text-sm text-gray-600">Company Email</span>
                            <span className="text-sm font-medium text-gray-900">
                                {companyEmail && companyEmail.trim() ? companyEmail : 'Not available'}
                            </span>
                        </div>

                        <div className="flex justify-between items-center py-2">
                            <span className="text-sm text-gray-600">Company Phone</span>
                            <span className="text-sm font-medium text-gray-900">
                                {companyPhone && companyPhone.trim() ? companyPhone : 'Not available'}
                            </span>
                        </div>
                    </div>

                    <div className="mt-6 pt-4 border-t border-gray-200">
                        <button
                            onClick={onClose}
                            className="w-full bg-orange-500 text-white py-2 px-4 rounded-lg hover:bg-orange-600 transition-colors duration-200"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

